var utils = require('../../utils')

// 送信ステータス
const SEND_STATUS = {
  SEND_NONE: 0,    // 未送信
  SEND_SUCCESS: 1, // 成功
  SEND_FAIL: 2,    // 失敗
  SEND_SENDING: 3, // 送信中
  SEND_CANCELED: 4 // 送信中止
}

// 送信ステータスClass
const SEND_STATUS_CLASS = [
  'label-default',  //0
  'label-success',  //1
  'label-danger',   //2
  'label-info',     //3
  'label-warning'   //4
]

// オーナータイプ
const OWNER_TYPE = {
  FACILITY: 0,    // 施設
  CLINIC: 1,      // クリニック
  CARE_OFFICE: 2 // 介護支援事業所
}

// FAX送信ステータス確認間隔（秒）
const FAX_SEND_STATUS_INTERVAL = 30

export default {
  name: 'send-pdf',
  utils: utils,
  data: function () {
    return {
      facilityId: null,
      facilityName: '',
      clinicId: null,
      clinicName: '',
      careOfficeId: null,
      careOfficeName: '',
      shopId: null,
      userId: null,
      shopName: '',
      pdfFile: { file: null, name: null, upload_path: null },
      pdfPath: null,
      csvFile: null,
      batchSending: false,
      csvParsing: false,
      total: 0,
      finished: 0,
      percent: 0,
      sendStatuses: null,
      cancelSendPdf: false,
      faxStatusTimerId: null,
      utils: utils,
      // 正常入力値保持用
      ac: {
        shop_name: '',
        facility_name: '',
        clinic_name: '',
        careoffice_name: ''
      }
    }
  },
  /** 画面遷移時 */
  beforeRouteLeave (to, from, next) {
    // オートコンプリートイベント削除
    utils.autocompleteEventRemove({$: $, elem:'#facility_name_autocomplete'})
    utils.autocompleteEventRemove({$: $, elem:'#careoffice_name_autocomplete'})
    utils.autocompleteEventRemove({$: $, elem:'#clinic_name_autocomplete'})
    next()
  },
  created: function () {
    // this.$store.dispatch('SHOP_SEARCH')
    // this.$store.dispatch('SHOP_SEARCH', {data: {all_get: true}, 'allShopName': this._self.$t('AllShopName'), callback: () => {}})

    if (this.$store.getters.canManage) {
      this.shopId = this.$store.getters.currentShopId
      this.shopName = this.$store.getters.currentShopName
      this.userId = this.$store.getters.userId
    }
    this.getShops()
    this.$store.dispatch('SEND_PDF_ADDRESS_DELETE_ALL')

    this.autocompleteAllClear({})

    // オートコンプリートイベント
    utils.autocompleteEvent({$:$, elem:'#facility_name_autocomplete',   search:() => {}, searchParams:false, searchAutocomplete:this.getFacilities,  setSearchData:this.setSearchFacility,   clear:this.clearFacilities})
    utils.autocompleteEvent({$:$, elem:'#careoffice_name_autocomplete', search:() => {}, searchParams:false, searchAutocomplete:this.getCareOffices, setSearchData:this.setSearchCareOffice, clear:this.clearCareOffices})
    utils.autocompleteEvent({$:$, elem:'#clinic_name_autocomplete',     search:() => {}, searchParams:false, searchAutocomplete:this.getClinics,     setSearchData:this.setSearchClinic,     clear:this.clearClinics})
  },
  mounted () {
    // ヘルプボタン表示
    utils.helpModalShow()
  },
  computed: {
    /** 施設 */
    facilities () {
      return this.$store.getters.facilitiesAutocomplete
    },
    /** クリニック */
    clinics () {
      return this.$store.getters.clinicsAutocomplete
    },
    /** 介護支援事業所 */
    careOffices () {
      return this.$store.getters.careOfficesAutocomplete
    },
    /** 店舗 */
    shops () {
      return this.$store.getters.shops
    },
    /** 店舗リスト */
    shopsName () {
      return this.$store.getters.shopsAutocomplete
    },
    /** 送信宛先 */
    addresses () {
      return this.$store.getters.addresses
    },
    /** 通知 */
    notifications () {
      return this.$store.getters.sendPdfNotifications
    },
    notify() {
      return this.$store.getters.sendPdfNotify
    },
    /** ロード中 */
    loading () {
      return this.$store.getters.apiLoading
    },
    pdfFileName () {
      return this.pdfFile.name
    },
    pdfFilePath () {
      return this.pdfPath
    }
  },
  methods: {
    /** 一括送信可否 */
    canBatchSend: function () {
      if (utils.isBlank(this.pdfFile.file)) {
        return false
      }
      if (this.batchSending) {
        return false
      }
      if (this.csvParsing) {
        return false
      }
      if (this.addresses.length < 1) {
        return false
      }
      return true
    },

    /** 施設 */
    getFacilities: function () {
      this.facilityId = null
      this.$store.dispatch('FACILITY_SEARCH', {
        data: {
          facility_name: this.facilityName.trim() === this.$t('send_pdf.facility_all.name') ? '' : this.facilityName.trim(),
          shop_id: this.shopId,
          all_get: true,
        },
        all: true,
        facility_all: { id: this.$t('send_pdf.facility_all.id'), name: this.$t('send_pdf.facility_all.name') },
        autocomplete: true
      })
    },
    clearFacilities: function () {
      if (this.ac.facility_name !== this.facilityName) {
        this.facilityName = this.ac.facility_name
        this.$store.dispatch('SEND_PDF_MSG_ALERT', { message_i18n: 'messages.select_list_item', danger: true })
      }
      this.autocompleteAllClear({facility: 0})
    },
    setSearchFacility: function (facilityId, facilityName) {
      this.facilityId = facilityId
      this.facilityName = facilityName
      this.ac.facility_name = facilityName
      this.autocompleteAllClear({facility: 0})
    },

    /** クリニック */
    getClinics: function () {
      this.clinicId = null
      this.$store.dispatch('CLINIC_SEARCH', {
        data: {
          clinic_name: this.clinicName.trim() === this.$t('send_pdf.clinic_all.name') ? '' : this.clinicName.trim(),
          shop_id: this.shopId,
          all_get: true,
        },
        all: true,
        clinic_all: { id: this.$t('send_pdf.clinic_all.id'), name: this.$t('send_pdf.clinic_all.name') },
        autocomplete: true
      })
    },
    clearClinics: function () {
      if (this.ac.clinic_name !== this.clinicName) {
        this.clinicName = this.ac.clinic_name
        this.$store.dispatch('SEND_PDF_MSG_ALERT', { message_i18n: 'messages.select_list_item', danger: true })
      }
      this.autocompleteAllClear({clinic: 0})
    },
    setSearchClinic: function (clinicId, clinicName) {
      this.clinicId = clinicId
      this.clinicName = clinicName
      this.ac.clinic_name = clinicName
      this.autocompleteAllClear({clinic: 0})
    },

    /** 介護支援事業所 */
    getCareOffices: function () {
      this.careOfficeId = null
      this.$store.dispatch('CARE_OFFICE_SEARCH', {
        data: {
          careoffice_name: this.careOfficeName.trim() === this.$t('send_pdf.care_office_all.name') ? '' : this.careOfficeName.trim(),
          shop_id: this.shopId,
          all_get: true,
        },
        all: true,
        care_office_all: { id: this.$t('send_pdf.care_office_all.id'), name: this.$t('send_pdf.care_office_all.name') },
        autocomplete: true
      })
    },
    clearCareOffices: function () {
      if (this.ac.careoffice_name !== this.careOfficeName) {
        this.careOfficeName = this.ac.careoffice_name
        this.$store.dispatch('SEND_PDF_MSG_ALERT', { message_i18n: 'messages.select_list_item', danger: true })
      }
      this.autocompleteAllClear({care_office: 0})
    },
    setSearchCareOffice: function (careOfficeId, careOfficeName) {
      this.careOfficeId = careOfficeId
      this.careOfficeName = careOfficeName
      this.ac.careoffice_name = careOfficeName
      this.autocompleteAllClear({care_office: 0})
    },

    /** 店舗 */
    getShops: function () {
      this.$store.dispatch('SHOP_SEARCH', {data: {all_get: true}, 'allShopName': this._self.$t('AllShopName'), callback: () => {}})
    },

    autocompleteAllClear: function(param) {
      var time = Object.assign({}, {facility: 100, clinic: 100, care_office: 100}, param)
      this.$store.dispatch('FACILITY_AUTOCOMPLETE_CLEAR', time.facility)
      this.$store.dispatch('CLINIC_AUTOCOMPLETE_CLEAR', time.clinic)
      this.$store.dispatch('CARE_OFFICE_AUTOCOMPLETE_CLEAR', time.care_office)
    },

    /** PDFファイルを選択 */
    selectedPdf: function(event) {
      if (event) {
        var files = event.target.files
        var file = files[0]
        this.pdfPath = window.URL.createObjectURL(file)
        if (file == undefined) {
          this.pdfFile = {
            file: null,
            name: null,
            upload_path: null
          }
        } else {
          this.pdfFile = {
            file: file,
            name: file.name,
            upload_path: null
          }
        }
      }
    },

    /** CSVファイルを選択 */
    selectedCsv: function(event) {
      if (event) {
        event.preventDefault()
        var files = event.target.files
        this.csvFile = files[0]
      }
    },

    /** CSVファイルの送信宛先情報を取得 */
    getCsvAddresses: function() {
      this.csvParsing = true
      if (this.csvFile) {
        var form = new FormData()
        form.append('file', this.csvFile)
        this.$store.dispatch('SEND_PDF_CSV_ADDRESS_PARSE', {
          data: form
        })
      }
      this.csvParsing = false
    },

    /** 施設の送信宛先情報を取得 */
    getFacilityAddresses: function() {
      if (utils.isPresent(this.facilityId)) {
        this.$store.dispatch('SEND_PDF_ADDRESS_SEARCH', {
          data: {
            shop_id: this.shopId,
            id: this.facilityId,
            type: OWNER_TYPE.FACILITY
          }})
      }
    },

    /** クリニックの送信宛先情報を取得 */
    getClinicAddresses: function() {
      if (utils.isPresent(this.clinicId)) {
        this.$store.dispatch('SEND_PDF_ADDRESS_SEARCH', {
          data: {
            shop_id: this.shopId,
            id: this.clinicId,
            type: OWNER_TYPE.CLINIC
          }})
      }
    },

    /** 介護支援事業所の送信宛先情報を取得 */
    getCareOfficeAddresses: function() {
      if (utils.isPresent(this.careOfficeId)) {
        this.$store.dispatch('SEND_PDF_ADDRESS_SEARCH', {
          data: {
            shop_id: this.shopId,
            id: this.careOfficeId,
            type: OWNER_TYPE.CARE_OFFICE
          }})
      }
    },

    /** 送信宛先情報を削除 */
    deleteAddress: function(index) {
      this.$store.dispatch('SEND_PDF_ADDRESS_DELETE', {
        index: index
      })
    },

    /** 送信宛先情報を全削除 */
    deleteAllAddresses: function() {
      this.$store.dispatch('SEND_PDF_ADDRESS_DELETE_ALL')
    },

    /** PDF送信（PDFアップロード） */
    sendPdf: function() {
      this.total = this.addresses.length
      this.finished = 0
      this.percent = 0
      this.sendStatuses = []
      this.cancelSendPdf = false
      this.pdfFile.upload_path = null

      var form = new FormData()
      form.append('file', this.pdfFile.file)
      this.$store.dispatch('SEND_PDF_UPLOAD_PDF_FILE', {
        data: form
      })
      .then(
        (data) => {
          this.pdfFile.upload_path = data.file_path
          var $btnOpen = document.getElementById('send_modal_open')
          $btnOpen.click()
        },
        () => {
        }
      )
    },

    /** PDF送信（一括送信） */
    sendAll: function() {
      this.batchSending = true
      var data = {
        shop_id: this.shopId,
        user_id: this.userId,
        file_name: this.pdfFile.name,
        file_path: this.pdfFile.upload_path
      }
      this.send(data, (statuses, cancel) => {
        if (!cancel) {
          this.$store.dispatch('SEND_PDF_SEND_COMPLETED')
        } else {
          this.$store.dispatch('SEND_PDF_SEND_CANCELED')
        }
        this.batchSending = false
      })
    },

    /** PDF送信（ダイアログでの個別送信） */
    send: function(data, callback) {
      var $store = this.$store

      if (this.cancelSendPdf) {
        this.cancel(callback)
        return
      }
      if (this.finished >= this.total) {
        this.ok(callback)
        return
      }

      var start = this.finished
      var end = start + 1

      if (end > this.total) {
        end = this.total
      }

      this.percent = Math.round((this.finished / this.total) * 100)
      var _addresses = this.addresses.slice(start, end)
      for (var i = 0; i < _addresses.length; i++) {
        _addresses[i].index = start
      }

      var will_complete = 0
      if (end == this.total) {
        will_complete = 1
      }

      data.addresses = _addresses
      $store.dispatch('SEND_PDF_SEND', {
        data: data
      })
      .then(
        (res) => {
          Array.prototype.push.apply(this.sendStatuses, res.send_statuses)
          this.finished = end
          if (will_complete == 1) {
            this.percent = 100
            this.ok(callback)
          } else {

            // 次の送信宛先に送付
            this.send(data, callback)
          }
        },
        () => {
          this.cancel(callback)
        }
      )
    },

    /** PDF送信（送信完了） */
    ok: function(callback) {
      setTimeout(this.hideModal, 700)
      if (callback) {
        callback(this.sendStatuses, false)
      }
    },

    /** PDF送信（キャンセル） */
    cancel: function(callback) {
      if (callback) {
        callback(this.sendStatuses, true)
      }
      this.hideModal()
    },

    /** モーダル非表示 */
    hideModal: function() {
      var $btnClose = document.getElementById('send_modal_close')
      $btnClose.click()
      this.percent = 0
    },

    /** モーダルからキャンセル */
    cancelModal: function() {
      this.percent = 0
      this.cancelSendPdf = true
    },

    /** 戻る */
    goPrev: function() {
      this.$router.push({ path: '/', query: { type: this.$router.currentRoute.query.type }})
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/send-pdf.js